<template lang="pug">
    Modal
        .form
            h2 Are you sure you want to delete this product?
            .button-wrapper
                button.button.button__submit(
                    @click="remove()"
                ) Yes
                button.button(
                    @click="cancel()"
                ) Cancel
</template>
<script>
import Modal from '../general/Modal';
import store from '../../store';
import Services from '../../services/Services';
import { postResource } from '../../services/Utils.js';
import VueNotifications from 'vue-notifications';
export default {
    name: 'DeleteProductModal',
    components: {
        Modal
    },
    notifications: {
        showSuccessMsg: {
        type: VueNotifications.types.success,
        title: '',
        icon: '✅'
        },
        showErrorMsg: {
        type: VueNotifications.types.error,
        title: '',
        icon: '❗️'
        }
    },
    methods: {
        remove(){
            const productId = store.getters.getActiveProduct._id;
            postResource(`/v1/products/delete?id=${productId}`, false, )
                .then(res => {
                    this.showSuccessMsg({
                        message: `Product successfully deleted.`
                    });
                    console.log('success!', res);
                    this.$router.push(`/products/`);
                    return res;
                })
                .catch(error => {
                    let message = 'An error occurred. Please try again.';
                    if(error.error){
                        message = error.error;
                    }
                    this.showErrorMsg({
                    message
                    });
                });
        },
        cancel(){
            store.commit('hideModals', true);
        }

    }
}
</script>
<style lang="scss" scoped>
h2 {
    text-align: center;
}

.form {
    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.form__control-group.rule__control-group--select:after {
    top: 20px;
}

.button-wrapper {
    margin: auto;
    display: flex;
    width: 100%;
    max-width: 300px;
    justify-content: space-between;
    margin-top: 2rem;

    button {
        display: block;
        border-radius: 3px;
        cursor: pointer;
        outline: none;
        font-size: 1.2rem;
        width: 130px;

        &.button__submit {
            width: 130px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/DeleteProduct.vue